import { propertyQueryKeys as e } from "./usePropertiesQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { propertiesApi as r } from "@maat/api-main";
//#region src/properties/useUpdateListingAmenitiesMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: ({ propertyId: e, amenityIds: t }) => r.patchPropertyAmenities(e, { amenityIds: t }),
		onSuccess: (t, { propertyId: n }) => {
			i.invalidateQueries({ queryKey: e.property(n) }), i.invalidateQueries({ queryKey: e.hostFeed() });
		}
	});
};
//#endregion
export { i as useUpdateListingAmenitiesMutation };
